import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import { selectUser } from "../../utils/redux/userSlice";
import { useSelector } from "react-redux";
import { InputGroup, Modal, Spinner } from "react-bootstrap";
import { useState } from "react";
import { ErrorMessage, Field, Form, Formik, FormikHelpers, useFormikContext } from "formik";
import { changePassword } from "../../utils/services/user.service";
import { hash } from "bcryptjs";
import './ModalChangePassword.scss'
import { passwordRegex } from "../../utils/const";

interface FormValues {
    oldPassword: string,
    newPassword: string,
}

interface FormErrors {
    oldPassword?: string,
    newPassword?: string,
}

const ModalChangePasswordComponent = (props: { showModal: boolean, onHide: (e: any) => void }) => {

    const user = useSelector(selectUser)
    const [errorChangePwd, setErrorChangePwd] = useState({ error: false, msg: '' })
    const [pwdChanged, setPwdChanged] = useState(false)
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation();

    const initialValues: FormValues = {
        oldPassword: '',
        newPassword: '',
    };

    const validationSchema = Yup.object().shape({
        oldPassword: Yup.string().required(t('OldPasswordRequired')),
        newPassword: Yup.string()
            .matches(passwordRegex, t('PasswordMustContainAtLeast8Characters'))
            .required(t('NewPassordRequired')),
    });

    const changePwd = async (values: FormValues, { resetForm }: FormikHelpers<FormValues>) => {
        setLoading(true)
        const {...newFormValues } = values;
        newFormValues.newPassword = await hash(newFormValues.newPassword, 10)

        changePassword(user.token, user.iduser, newFormValues)
            .then((json: any) => {
                if (json.code !== 200) {
                    setErrorChangePwd((prevErr) => ({
                        ...prevErr,
                        error: true,
                        msg: t('IncorrectPassword')
                    }))
                } else {
                    setPwdChanged(true)
                    resetForm()
                    setTimeout(() => props.onHide(null), 2000)
                }
            })
            .catch((e) => {
                console.log('errorUser', e);
                setErrorChangePwd((prevErr) => ({
                    ...prevErr,
                    error: true,
                    msg: t('ErrorChangePassword')
                }))
            }).finally(() => {
                setTimeout(() => {
                    setLoading(false)
                    setPwdChanged(false);

                    setErrorChangePwd((prevErr) => ({
                        ...prevErr,
                        error: false,
                        msg: ''
                    }))
                }, 2000)
            })
    }

    return (
        <>
            <Modal show={props.showModal} keyboard={false} backdrop={'static'}>
                <Modal.Header className="position-relative d-block modalThemeHeader">
                    <p className="modal-title-custom m-0 text-start text-lg-center">{t('ChangePassword')}</p>
                </Modal.Header>
                <Modal.Body>
                    {errorChangePwd.error && <div className="alert alert-danger" role="alert"> {errorChangePwd.msg}</div>}
                    {pwdChanged && <div className="alert alert-success" role="alert">{t('PasswordChanged')}</div>}
                    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={changePwd}>
                        <InnerForm onHide={props.onHide} loading={loading} />
                    </Formik>
                </Modal.Body>
                <Modal.Footer className='position-relative d-block text-center'>
                    <button className='btn-Custom btn-IDGrey' onClick={props.onHide}>{t("Cancel")}</button>
                    <button className='btn-Custom btn-IDGreen' type="submit" form="changePwdForm" >{t("Change")}</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

const InnerForm = (props: { onHide: (e: any) => void, loading: boolean }) => {
    const [actualPasswordVisibility, setActualPasswordVisibility] = useState(false)
    const [newPasswordVisibility, setNewPasswordVisibility] = useState(false)
    const { t } = useTranslation();
    const { errors, touched } = useFormikContext<FormErrors>()
    return (
        <div className="container-module">
            <Form id="changePwdForm" className='form' >
                <div className='row'>
                    <div className="col">
                        <label>{t('OldPassword')}</label>
                        <InputGroup className="password">
                        <Field className={`form-control ${errors.oldPassword && touched.oldPassword ? 'is-invalid' : ''}`} name="oldPassword" type={actualPasswordVisibility ? "text" : "password"} />
                        <InputGroup.Text onClick={()=>setActualPasswordVisibility(!actualPasswordVisibility)}>
                        <i className={actualPasswordVisibility ? "bi bi-eye-slash" : "bi bi-eye"} ></i>
                        </InputGroup.Text>
                        </InputGroup>
                    </div>
                </div>
                <div className='row'>
                    <div className="col mt-2">
                        <label>{t('NewPassword')}</label>
                        <InputGroup className="password">
                        <Field className={`form-control ${errors.newPassword && touched.newPassword ? 'is-invalid' : ''}`} name="newPassword" type={newPasswordVisibility ? "text" : "password"} />
                        <InputGroup.Text onClick={()=>setNewPasswordVisibility(!newPasswordVisibility)}>
                        <i className={newPasswordVisibility ? "bi bi-eye-slash" : "bi bi-eye"}  ></i>
                        </InputGroup.Text>
                        </InputGroup>
                        <ErrorMessage name="newPassword" component="div" className="text-danger mt-1" />
                    </div>
                </div>
                {props.loading && <div className='row mt-2'>
                    <div className="col">
                        <div className="text-center mt-1"><Spinner animation="border" variant="success" /></div>
                    </div>
                </div>}
            </Form>
        </div>
    )
}

export default ModalChangePasswordComponent;